import React from 'react';
import classnames from "classnames"

import Modal from './../shared/Modal';
import Button from './../shared/Button';
import time from '../../img/time@3x.png'

import baseStyles from 'custom/base.styl';

const TimeoutModal = props => {
  const { onContinue } = props;
  return (
    <Modal>
      <img className={baseStyles.content_board__icon} src={time} alt="time" width="66px" />
      <div className={baseStyles.header}><div className={baseStyles.title_middle}>Oops…Time’s up..</div></div>

      <p className={classnames(baseStyles.title_extra_small, baseStyles.text_danger, baseStyles.mb_20)}>
        The time to complete the test is over. <br/>
        But you can get additional time if you still <br/>
        want to pass the test.
      </p>

      <Button onClick={onContinue}>Get additional 20 min</Button>
    </Modal>
  );
};

export default TimeoutModal;



// WEBPACK FOOTER //
// ./src/components/AcademicTest/TimeoutModal.js